import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import Notifications from "react-notification-system-redux";
import {
    MuiThemeProvider,
    createMuiTheme,
    withStyles,
} from "@material-ui/core/styles";
import createPalette from "@material-ui/core/styles/createPalette";
import "./App.css";
import moment from "moment";
import "moment/locale/fr";
import { withRouter } from "react-router-dom";
import LocationListener from "../components/LocationListener";
import { loadActiveUser } from "../redux/users/usersActions";
import HeaderContainer from "./Layout/HeaderContainer";
import BodyContainer from "./Layout/BodyContainer";
import Loader from "../components/Basics/Loader";
import Background from "../images/background_cesbron.png";
import {
    hideMenu,
    scrollYChange,
} from "../redux/contextInfos/contextInfosActions";
import BackToTop from "../components/Basics/BackToTop";
import { arraysAreSame } from "../lib/array_helper";
import Debugger from "../components/Debug/Debugger";
import { mobileAndTabletCheck } from "../utils";
import performanceModeManager from "../performanceModeManager";
import BrowserCompatibility from "../components/Basics/BrowserCompatibility";
import { getStateAccessor } from "../lib/evaluateStringAsCodeHelper";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../utils.css";
import { MYOPEN } from "../constants";
import { loadCurrentNews } from '../redux/news/newsActions';
import { authorizedAppsFetchData } from "../redux/authorizedApps/authorizedAppsActions";
import { initPeriodicCheckOfTTE } from "../redux/imputations/imputationsActions";
import { loadLoggedEmployee } from "../redux/employees/loggedEmployeeActions";

// import { connect } from 'react-redux'>
export const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: createPalette({
        primary: {
            light: "#5887ee",
            main: "#1057C8",
            dark: "#00338a",
            contrastText: "#fff",
        },
        secondary: {
            light: "#ff8b46",
            main: "#FE5815",
            dark: "#c31f00",
            contrastText: "#fff",
        },
    }),
});

const style = {
    backgroundImage: "url(" + Background + ")",
};

class App extends Component {
    constructor(props) {
        super(props);

        moment.locale("fr");
        this.state = props.getDefaultSyncState();
        this.state.scrollPosition = 0;
        this.state.enableDebugger = mobileAndTabletCheck(); //Enable only on mobile device else we lose informations on console logs

        this.container = React.createRef();

        if (this.props.activeUser && this.props.activeUser.application === MYOPEN && this.props.contextualProps.loadInterventionModel)
            this.props.loadInterventionModel();

        performanceModeManager();
        this.props.loadCurrentNews();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeUser !== this.props.activeUser && this.props.activeUser) {
            this.props.fetchData(this.props.activeUser);
            this.launchSynchronisations();
        }
    }

    componentDidMount() {
        this.props.loadActiveUser((user) => {
            if (user) {
                this.launchSynchronisations();

                if (user.application === MYOPEN)
                    this.props.loadLoggedEmployee(user.id, user.emp_id, () => {
                        this.launchPeriodicCheckOfTTE();
                    });
            }
        });
    }

    launchSynchronisations() {
        this.props.initSynchronisations(
            this.state,
            getStateAccessor(this.props),
            this.props.history,
            this.props.interventionsFilters,
            this.props.siteMonitoringsFilters
        );
    }

    launchPeriodicCheckOfTTE() {
        this.props.initPeriodicCheckOfTTE(this.props.loggedEmployee.loggedEmployee, this.props.activeUser);
    }

    onScroll() {
        this.displayOrHideStickyMenu();
    }

    displayOrHideStickyMenu() {
        if (this.container.current.scrollTop > this.state.scrollPosition)
            this.props.hideMenu(true);
        else this.props.hideMenu(false);

        this.setState({ scrollPosition: this.container.current.scrollTop });
        this.props.scrollYChange(this.container.current.scrollTop);
    }

    backToTop() {
        this.container.current.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    shouldComponentUpdate(nextProps, prevState) {
        return (
            !arraysAreSame(this.props.notifications, nextProps.notifications) ||
            this.props.activeUser !== nextProps.activeUser ||
            this.props.context.debugging !== nextProps.context.debugging ||
            this.state.enableDebugger !== prevState.enableDebugger
        );
    }

    render() {
        const { notifications } = this.props;

        return (
            <MuiThemeProvider theme={theme}>
                <div
                    style={style}
                    id="container"
                    onScroll={this.onScroll.bind(this)}
                    onTouchMove={this.onScroll.bind(this)}
                    ref={this.container}
                    className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding my-open-container"
                >
                    <LocationListener>
                        <HeaderContainer
                            appBar={this.props.appBar}
                            publicRoutes={this.props.publicRoutes}
                            privateRoutes={this.props.privateRoutes}
                        />
                        <div className="body-container">
                            <BodyContainer
                                container={this.container}
                                publicRoutes={this.props.publicRoutes}
                                privateRoutes={this.props.privateRoutes}
                            />
                        </div>
                    </LocationListener>
                    <Notifications notifications={notifications} />
                    <BackToTop backToTop={this.backToTop.bind(this)} />
                    {this.state.enableDebugger && this.props.context.debugging && (
                        <Debugger />
                    )}
                </div>
                <Loader />
                <BrowserCompatibility />
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    notifications: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        notifications: state.notifications,
        activeUser: state.activeUser,
        context: state.context,
        interventionsFilters: state.interventions,
        siteMonitoringsFilters: state.siteMonitorings.siteMonitoringsFilters,
        loggedEmployee: state.loggedEmployee,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadActiveUser: (onSuccess) => dispatch(loadActiveUser(onSuccess)),
        hideMenu: (value) => dispatch(hideMenu(value)),
        scrollYChange: (scrollY) => dispatch(scrollYChange(scrollY)),
        loadInterventionModel: () => dispatch(ownProps.contextualProps.loadInterventionModel()),
        loadCurrentNews: () => dispatch(loadCurrentNews()),
        fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
        initPeriodicCheckOfTTE: (loggedEmployee, user) => dispatch(initPeriodicCheckOfTTE(loggedEmployee, user)),
        loadLoggedEmployee: (userId, empId, onSuccess) => dispatch(loadLoggedEmployee(userId, empId, onSuccess)),
        initSynchronisations: (
            state,
            stateAccessor,
            history,
            interventionsFilters,
            siteMonitoringsFilters
        ) =>
            dispatch(
                ownProps.initSynchronisations(
                    state,
                    stateAccessor,
                    history,
                    interventionsFilters,
                    siteMonitoringsFilters
                )
            ),
    };
};

export default compose(
    withRouter,
    withStyles({ withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps)
)(App);
